import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../entities';
import { TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { ForgePioSharepointIcon } from './icon';
import { ForgePioSharepointSearchResultIcon } from './search-result-icon';

export const forgePioSharepointConfig: ThirdPartyConfig = {
	displayName: 'SharePoint by Pio',
	id: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
	resourceType: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
	icon: get3PLogo(ForgePioSharepointIcon, 'ForgePioSharepoint', 'medium'),
	searchResultIcon: get3PLogo(ForgePioSharepointSearchResultIcon, 'ForgePioSharepoint', 'large'),
	integrationAri: 'ari:cloud:platform::integration/7yrzYPlAOcZAif2tIymeDXBUNUAxI95G',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: false,
	isEnabled: () => true,
	displayWorkspaceNameAsProductName: true,
};
